<h2 class="text-lg font-app-bold">
  {{ "storedDocuments.documentListTitle" | translate }}
</h2>
<span class="inline-block text-dark">{{
  this.documents &&
    (this.documents.length === 0
      ? ("storedDocuments.documentCount.none" | translate)
      : ("storedDocuments.documentCount.".concat(this.documents.length > 1 ? "multiple" : "one")
        | translate: { count: this.documents.length }))
}}</span>
<div
  *ngIf="documents && documents.length > 0"
  class="grid grid-cols-2 gap-4 mt-4">
  <app-stored-documents-list-category-filter
    [categories]="categories"
    [(selectedCategory)]="categoryFilter"
    (sendEditCategoryEvent)="editCategoryEvent($event)" />
  <app-stored-documents-list-sort
    [(selectedSorting)]="sorting"
    [defaultSorting]="defaultSorting" />
</div>
<button
  *ngIf="sortAndFilterResetVisible"
  pButton
  type="button"
  (click)="resetSortAndFilter()"
  class="text-sm text-primary self-end mx-1 mt-2 focus:shadow-none rounded-none">
  <span class="underline">{{ "storedDocuments.resetSortAndFilterButton" | translate }}</span>
</button>
<ul
  *ngIf="processedDocuments; else documentsLoading"
  class="flex flex-col gap-3 mt-4">
  <li *ngFor="let document of processedDocuments">
    <app-stored-documents-list-item
      [document]="document"
      (downloadAction)="onDownload($event)"
      (editAction)="onEdit($event)"
      (deleteAction)="onDelete($event)" />
  </li>
</ul>
<ng-template #documentsLoading
  ><p-progressSpinner
    ariaLabel="loading"
    class="self-center mt-6 text-primary"
/></ng-template>

